var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsItem',{staticClass:"details-field"},[_c('DetailsRow',{class:{ 'not-last': _vm.$slots.default }},[_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('span',{staticClass:"value",class:{ monospace: _vm.valueMonospace }},[_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("value")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }